import { render, staticRenderFns } from "./AssetForm.vue?vue&type=template&id=8d81b2e4&scoped=true&"
import script from "./AssetForm.vue?vue&type=script&lang=js&"
export * from "./AssetForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetForm.vue?vue&type=style&index=0&id=8d81b2e4&lang=scss&scoped=true&"
import style1 from "./AssetForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d81b2e4",
  null
  
)

export default component.exports